export const getBlocksError = (error: any): Record<string, any> | undefined =>
  error?.graphQLErrors?.find((item: any) => item.extensions?.blocks)?.extensions
    .blocks || error?.extensions?.blocks

export const isStaleBlocksError = (error: any) =>
  ["stale_content", "stale_completion"].includes(getBlocksError(error)?.code)

export function getBlocksRecoveryURL(error: any, currentURL: string) {
  const url = new URL(currentURL)
  const navigation = getBlocksError(error)?.navigation_context
  if (
    navigation &&
    Number.isSafeInteger(navigation.cohort_id) &&
    navigation.cohort_id > 0 &&
    Number.isSafeInteger(navigation.step_id) &&
    navigation.step_id > 0
  ) {
    url.pathname = url.pathname.replace(
      /\/\d+\/path\/step\/[^/]+\/?/,
      `/${navigation.cohort_id}/path/step/${navigation.step_id}/`
    )
  }
  url.hash = ""
  return url.toString()
}
